export const Entitlements = {
  MEMBERSHIP_REFERRAL: 'MEMBERSHIP_REFERRAL',
} as const;

export type Entitlements = typeof Entitlements[keyof typeof Entitlements];
